import { computed, unref } from 'vue';

import { toTraitId } from '@modules/latchkey/utils';
import { useProductType } from '@composables/useProductType';
import { useInitPrice, usePriceParser } from '../../price/composables/mcl-utils';
import { usePrice } from '../../price/composables/mcl-utils/usePrice';

/**
 *
 * @param  {ProductId} id
 * @param {Product} product
 * @param {import('vue').DeepReadonly<SelectedLatchkey>} initialSelectedLatchkey
 * @param {ParsedLatchkeys.latchkeyNames[LatchkeyName]} latchkeyNames
 *
 * @return {void}
 */
function useInitEachSize(id, product, initialSelectedLatchkey, latchkeyNames) {
  const latchKeyLastIndex = latchkeyNames.length - 1;
  const productRelationships = product?.relationships ?? {};

  latchkeyNames.forEach((latchkeyName, index) => {
    productRelationships.selectedLatchKey = latchkeyName; // TODO -> refactor a less hacky solution
    useInitPrice({ id: toTraitId(id, latchkeyName), data: usePriceParser(product) });
    if (index === latchKeyLastIndex) { // TODO -> refactor a less hacky solution
      productRelationships.selectedLatchKey = initialSelectedLatchkey;
    }
  });
}

/**
 *
 * @param {import('@vueuse/core').MaybeRef<ProductId>} id
 * @param {import('vue').ComputedRef<Product>} product
 * @param {import('vue').DeepReadonly<SelectedLatchkey>} selectedLatchkey
 * @param {ParsedLatchkeys.latchkeyNames[LatchkeyName]} latchkeyNames
 * @param {SelectedTraits.selectedUpcId} selectedUpcId
 * @param {SelectedTraits.selectedColor} selectedColor
 * @param {SelectedTraits.selectedSize} selectedSize
 *
 * @returns {PdpSelectedPrice.selectedPrice}
 */
export default function usePriceLatchkey({
  id, product, selectedLatchkey, latchkeyNames, selectedUpcId, selectedColor, selectedSize,
}) {
  const { isConsolidatedLatchKey } = useProductType();

  if (!isConsolidatedLatchKey) {
    return computed(() => null);
  }
  const traitId = computed(() => (selectedLatchkey.value ? toTraitId(id, selectedLatchkey.value) : ''));

  useInitEachSize(id, unref(product), unref(selectedLatchkey), latchkeyNames);

  const { selectedPrice } = usePrice({
    id: traitId, selectedUpcId, selectedColor, selectedSize,
  });

  return selectedPrice;
}
